export const bulletStories = [
    {
        label: 'custom range',
        link: {
            kind: 'Bullet',
            story: 'custom range',
        },
    },
    {
        label: 'custom measure',
        link: {
            kind: 'Bullet',
            story: 'custom measure',
        },
    },
    {
        label: 'custom marker',
        link: {
            kind: 'Bullet',
            story: 'custom marker',
        },
    },
    {
        label: 'custom title',
        link: {
            kind: 'Bullet',
            story: 'custom title',
        },
    },
]
